'use es6';

const uuidToBytes = uuid => {
  // Assuming valid UUID
  const bytes = [];
  uuid.replace(/[a-fA-F0-9]{2}/g, hex => {
    bytes.push(parseInt(hex, 16));
  });
  return bytes;
};
const arrayBufferToBase64 = buffer => {
  const bytes = new Uint8Array(buffer);
  return window.btoa([...Array(bytes.byteLength)].reduce((t, v, i) => t + String.fromCharCode(bytes[i]), ''));
};
const convertUuidToBase64 = uuid => arrayBufferToBase64(uuidToBytes(uuid));
export default convertUuidToBase64;